var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"myPanel"},[_vm._v(" 目前QRCode: "+_vm._s(_vm.memberUUID)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }